import React from 'react'
import { Button, FormInstance, Modal } from 'antd';
import { TFunction } from 'i18next';
import classes from './TermsModal.module.scss';
import PDFViewer from 'components/Webviewer/Viewer/PDFViewer';
import { BuildNames, Languages, temsOfUse } from 'interfaces/IBuildLanguage';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';

const buildName: BuildNames | string = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' ? window.REACT_APP_BUILD_NAME : process.env.REACT_APP_BUILD_NAME || BuildNames.Tazadeal;

type TermsModalProps = {
  isTermsModalOpen?: boolean;
  setIsTermsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  t: TFunction;
  form: FormInstance<any>;
};

export default function TermsModal(
  {
    isTermsModalOpen,
    setIsTermsModalOpen,
    t,
    form,
  }: TermsModalProps
){
  const [isAvailableAccept, setIsAvailableAccept] = React.useState<boolean>(true);
  const isAlreadyAccept = form.getFieldValue(['is_accepted_terms']);

  const footerWithAcceptButton = (
    <Button
      disabled={!isAvailableAccept}
      type='primary'
      onClick={() => {
        form.setFieldsValue({ is_accepted_terms: true });
        form.validateFields(['is_accepted_terms']);
        setIsTermsModalOpen(false);
      }}
    >
      {t('Confirm.acceptTerms')}
    </Button>
  )

  return (
    <Modal
      className={cn(classes.modalLicense, getTheme())}
      width={'90%'}
      onCancel={() => setIsTermsModalOpen(false)}
      title={t('PersonalInfo.termsTitle')}
      open={isTermsModalOpen}
      centered={true}
      footer={isAlreadyAccept ? null : footerWithAcceptButton}
    >
      <div style={{height: '85vh'}}>
        <PDFViewer
          url={temsOfUse[buildName as BuildNames][Languages.Ru]} // [i18n.language as Languages] // useTranslation()
          isModal={false}
          // setIsAvailableAccept={setIsAvailableAccept}
        />
      </div>
    </Modal>
  )
}

